"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const style = __importStar(require("./styled"));
const MegaMenu_1 = __importDefault(require("./MegaMenu/MegaMenu"));
const Typography_1 = require("../../UI/Typography");
const Types_1 = require("Types");
const useMouseHover_1 = __importDefault(require("../../../Hooks/useMouseHover"));
const react_redux_1 = require("react-redux");
const megamenu_1 = require("@/Redux/Actions/megamenu");
const useDebounce_1 = __importDefault(require("../../../Hooks/useDebounce"));
const spa_core_1 = require("@episerver/spa-core");
const cart_1 = require("../../../Redux/Actions/cart");
const Search_1 = __importDefault(require("./Search/Search"));
const RegionSelectorButton_1 = __importDefault(require("./RegionSelectorButton/RegionSelectorButton"));
const OpenCartButton_1 = __importDefault(require("./OpenCartButton/OpenCartButton"));
const RegionMenu_1 = require("./RegionMenu/RegionMenu");
const MyHaldexDropdown_1 = __importDefault(require("../../../Components/MyHaldexDropdown"));
const Hooks_1 = require("@/Hooks");
const ExpressBanner_1 = __importDefault(require("../ExpressBanner"));
const useUserData_1 = __importDefault(require("../../../Hooks/useUserData"));
const Constants_1 = require("@/Constants");
const useInitialData_1 = __importDefault(require("../../../Hooks/useInitialData"));
const loginModal_1 = require("@/Redux/Actions/loginModal");
const Utils_1 = require("../../../Utils");
const MessageBanner_1 = __importDefault(require("app/Components/MessageBanner"));
const HeaderItems = ({ headerData, activeRegion, isRegional, showMiniCartIcon }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const userData = (0, useUserData_1.default)();
    const initialData = (0, useInitialData_1.default)();
    const [activeMenu, setActiveMenu] = (0, react_1.useState)();
    const [open, setOpen] = (0, react_1.useState)();
    const [isSearchOpen, setIsSearchOpen] = (0, react_1.useState)(false);
    const [isRegionOpen, setIsRegionOpen] = (0, react_1.useState)(false);
    const [isMyHaldexOpen, setIsMyHaldexOpen] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const isMegaMenuOpen = (0, react_redux_1.useSelector)((state) => state.menuToggle.isOpen);
    const miniCartData = (0, react_redux_1.useSelector)((state) => state.cart.cartData);
    const { ref, isMenuOpen } = (0, useMouseHover_1.default)();
    const activeMenuDebounceTime = 300;
    const isMenuOpenDebounceTime = 200;
    const debouncedActiveMenu = (0, useDebounce_1.default)(activeMenu, activeMenuDebounceTime);
    const debouncedIsMenuOpen = (0, useDebounce_1.default)(open, isMenuOpenDebounceTime);
    const cmsState = (0, spa_core_1.useCmsState)();
    const gotHeroImage = (cmsState && cmsState.iContent && 'heroImageDesktop' in cmsState.iContent) ||
        (cmsState && cmsState.iContent && 'heroImageMobile' in cmsState.iContent);
    const isForceReloadLink = `${!(cmsState === null || cmsState === void 0 ? void 0 : cmsState.iContent)}`;
    const [isTransparent, setIsTransparent] = (0, react_1.useState)(gotHeroImage);
    const [isScrolled, setIsScrolled] = (0, react_1.useState)(false);
    const transparent = isMegaMenuOpen ? false : isTransparent;
    const isEurope = Constants_1.EUROPE.includes((_a = initialData === null || initialData === void 0 ? void 0 : initialData.continent) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    const canSeeBanner = isEurope && userData.isAuthenticated && (userData === null || userData === void 0 ? void 0 : userData.roles) && userData.roles.includes(Types_1.UserRoles.EU_PLACE_ORDERS);
    const { t } = (0, Hooks_1.useTranslate)();
    const { isDesktopXLarge } = (0, Hooks_1.useDevice)();
    const openSearch = () => {
        setIsSearchOpen(true);
        dispatch((0, megamenu_1.setIsMegaMenuOpen)(false));
    };
    const openRegionSelector = (0, react_1.useCallback)(() => {
        setIsRegionOpen(true);
        dispatch((0, megamenu_1.setIsMegaMenuOpen)(false));
    }, []);
    const openCart = (0, react_1.useCallback)(() => {
        dispatch((0, cart_1.setIsOpen)(true));
    }, []);
    const handleScroll = (0, react_1.useCallback)(() => {
        if (window.scrollY === 0) {
            setIsTransparent(gotHeroImage);
        }
        else {
            setIsTransparent(false);
        }
        setIsScrolled(window.scrollY !== 0);
    }, [gotHeroImage]);
    const handleKeyPress = (event, item) => {
        var _a;
        if (event.key === 'Enter') {
            if (item.secondLevelItems.length > 0) {
                event.preventDefault();
                setActiveMenu({
                    secondLevelItems: item.secondLevelItems,
                    heading: item.title,
                    headingLink: item.uri,
                    promoRef: (_a = item.promoRef) === null || _a === void 0 ? void 0 : _a.id
                });
                dispatch((0, megamenu_1.setIsMegaMenuOpen)(true));
            }
        }
    };
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) {
            const path = window.location.pathname;
            const modifiedString = path.startsWith('/') ? path.substring(1) : path;
            const homePage = ((_b = modifiedString === null || modifiedString === void 0 ? void 0 : modifiedString.split('/')) === null || _b === void 0 ? void 0 : _b.length) <= 1;
            const langCookie = (0, Utils_1.getCookie)(Constants_1.LANGUAGE_COOKIE);
            const continentCookie = (0, Utils_1.getCookie)(Constants_1.CONTINENT_COOKIE);
            if (homePage && !isRegional && !langCookie && !continentCookie) {
                openRegionSelector();
            }
        }
    }, []);
    (0, react_1.useEffect)(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);
    (0, react_1.useEffect)(() => {
        setOpen(isMenuOpen);
        !isMenuOpen && setActiveMenu(null);
    }, [isMenuOpen]);
    (0, react_1.useEffect)(() => {
        dispatch((0, megamenu_1.setIsMegaMenuOpen)(debouncedIsMenuOpen));
        !debouncedIsMenuOpen && setActiveMenu(null);
    }, [debouncedIsMenuOpen, dispatch, setActiveMenu]);
    (0, react_1.useEffect)(() => {
        setIsTransparent(gotHeroImage);
    }, [gotHeroImage]);
    const headerLinks = (0, react_1.useMemo)(() => (react_1.default.createElement(style.HeaderLinks, { corporate: !isRegional }, headerData.menuData &&
        headerData.menuData.map((item, i) => (react_1.default.createElement(style.HeaderItem, { key: i, onMouseEnter: () => {
                var _a;
                return setActiveMenu({
                    secondLevelItems: item.secondLevelItems,
                    heading: item.title,
                    headingLink: item.uri,
                    promoRef: (_a = item.promoRef) === null || _a === void 0 ? void 0 : _a.id
                });
            }, onKeyDown: e => {
                handleKeyPress(e, item);
            }, isActive: (activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.heading) === item.title },
            react_1.default.createElement(style.HeaderItemsTitle, { type: Typography_1.Types.NAV_HEADER },
                react_1.default.createElement(style.Link, { "data-force-reload": isForceReloadLink, "$isTransparent": transparent, href: item.uri, onClick: () => dispatch((0, megamenu_1.setIsMegaMenuOpen)(false)) }, item.title))))))), [isRegional, transparent, activeMenu]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(style.Header, { "$isTransparent": transparent, isFixed: gotHeroImage, "$isScrolled": isScrolled },
            react_1.default.createElement(MessageBanner_1.default, null),
            react_1.default.createElement(ExpressBanner_1.default, { bannerText: t('/haldex/express_banner/title'), expiredText: t('/haldex/express_banner/expired'), canSeeBanner: canSeeBanner }),
            react_1.default.createElement(style.ItemsContainer, { ref: ref },
                react_1.default.createElement(style.HeaderItems, null,
                    react_1.default.createElement(style.LogoAndLinksContainer, null,
                        ((_b = headerData.settings) === null || _b === void 0 ? void 0 : _b.logo) && (react_1.default.createElement(style.LogoContainer, { "$lowerMargin": !isRegional && !isDesktopXLarge },
                            react_1.default.createElement("a", { href: headerData.LogoUrl, "data-force-reload": isForceReloadLink },
                                react_1.default.createElement(style.Image, { src: headerData.settings.logo, alt: "logo" })))),
                        !isRegional && headerLinks),
                    isRegional && react_1.default.createElement(Search_1.default, { isRegional: isRegional, isTransparent: transparent }),
                    react_1.default.createElement(style.OtherContainer, null,
                        ((_e = (_d = (_c = headerData === null || headerData === void 0 ? void 0 : headerData.settings) === null || _c === void 0 ? void 0 : _c.linkedSite) === null || _d === void 0 ? void 0 : _d.link) === null || _e === void 0 ? void 0 : _e.href) && (react_1.default.createElement(style.LinkedSite, { href: headerData.settings.linkedSite.link.href, target: (_f = headerData.settings.linkedSite.link) === null || _f === void 0 ? void 0 : _f.target, isRegional: isRegional }, transparent ? (react_1.default.createElement("img", { src: (_g = headerData.settings.linkedSite) === null || _g === void 0 ? void 0 : _g.whiteLogoUrl, alt: (_h = headerData.settings.linkedSite) === null || _h === void 0 ? void 0 : _h.text })) : (react_1.default.createElement("img", { src: (_j = headerData.settings.linkedSite) === null || _j === void 0 ? void 0 : _j.greyLogoUrl, alt: (_k = headerData.settings.linkedSite) === null || _k === void 0 ? void 0 : _k.text })))),
                        react_1.default.createElement(RegionSelectorButton_1.default, { isRegional: isRegional, transparent: transparent, openRegionSelector: openRegionSelector, activeRegion: activeRegion, isDesktopXLarge: isDesktopXLarge }),
                        !isRegional && (react_1.default.createElement(style.SearchIcon, { "$isTransparent": transparent, onClick: openSearch, "$lowerMargin": !isRegional && !isDesktopXLarge })),
                        isRegional && (react_1.default.createElement(style.MyHaldexContainer, { onClick: () => setIsMyHaldexOpen(true), "aria-label": t('/haldex/attributes/aria-label/my-haldex') },
                            react_1.default.createElement(style.MyHaldexIcon, { "$isTransparent": transparent }),
                            isMyHaldexOpen && (react_1.default.createElement(MyHaldexDropdown_1.default, { setIsLoginOpen: (value) => dispatch((0, loginModal_1.setIsLoginModalOpen)(value)), setIsMyHaldexOpen: setIsMyHaldexOpen })))),
                        isRegional && showMiniCartIcon && (react_1.default.createElement(OpenCartButton_1.default, { numberOfItems: miniCartData.numberOfItems, openCart: openCart, transparent: transparent }))),
                    isRegional && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(style.Break, null),
                        react_1.default.createElement(style.RegionalContainer, null, headerLinks)))),
                debouncedActiveMenu && !!((_l = debouncedActiveMenu === null || debouncedActiveMenu === void 0 ? void 0 : debouncedActiveMenu.secondLevelItems) === null || _l === void 0 ? void 0 : _l.length) && (react_1.default.createElement(MegaMenu_1.default, Object.assign({}, debouncedActiveMenu))))),
        react_1.default.createElement(style.Background, { isOpen: debouncedActiveMenu && !!((_m = debouncedActiveMenu === null || debouncedActiveMenu === void 0 ? void 0 : debouncedActiveMenu.secondLevelItems) === null || _m === void 0 ? void 0 : _m.length) }),
        isSearchOpen && react_1.default.createElement(Search_1.default, { setIsSearchOpen: setIsSearchOpen }),
        isRegionOpen && ((_o = headerData.settings) === null || _o === void 0 ? void 0 : _o.regions) && (react_1.default.createElement(RegionMenu_1.RegionMenu, { setIsRegionOpen: setIsRegionOpen, activeRegion: activeRegion, regions: headerData.settings.regions, linkedSite: (_p = headerData.settings) === null || _p === void 0 ? void 0 : _p.linkedSite }))));
};
exports.default = HeaderItems;
